import { Link } from "react-router-dom";
import { categories } from "@/mocks/posts";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-100 border-t border-primary-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-accent-500 text-background-50 font-heading font-bold text-lg">
                瓜
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">黑吃瓜网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              专注娱乐话题的吃瓜资讯站，每天整理今日爆料与新瓜汇总，把零散讨论梳理成清楚好读的时间线。
            </p>
            <p className="mt-4 text-xs text-foreground-600">
              内容均基于公开信息整理，未证实的说法会明确标注为讨论。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">站内导航</h3>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer whitespace-nowrap">首页</Link></li>
              <li><Link to="/breaking" className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer whitespace-nowrap">今日爆料</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer whitespace-nowrap">关于我们</Link></li>
              <li><Link to="/contact" className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer whitespace-nowrap">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">主题分类</h3>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/breaking?cat=${cat.slug}`}
                    className="text-sm text-foreground-700 hover:text-primary-700 cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-foreground-950">订阅与联系</h3>
            <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
              每周一封精选汇总，把当周最热的话题一次性补齐。
            </p>
            <Link
              to="/contact"
              className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-send-line" aria-hidden="true"></i>
              订阅与投稿
            </Link>
            <p className="mt-4 text-sm text-foreground-700">
              邮箱：<a href="mailto:hi@heichigua.example.com" className="hover:text-primary-700 whitespace-nowrap">hi@heichigua.example.com</a>
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-primary-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">© 2026 黑吃瓜网 · 娱乐话题资讯整理</p>
          <p className="text-xs text-foreground-600">本站内容仅作话题讨论与信息整理，请理性吃瓜。</p>
        </div>
      </div>
    </footer>
  );
}